export default __webpack_public_path__ + "static/media/MPCAS.c3b17819.png";